import React from 'react'
import { Link } from "react-router-dom";
const Header = ({ onBack }) => {
    return (
        <div
          className="header header-transparent header-logo-center"
          style={{ position: "absolute", top: 0, left: 0, right: 0, zIndex: 10, height: "90px" }}
        >
        <Link to="/" className="header-title color-theme">
        <img
          src="/XLog3D Logo_Red.png"
          alt="Xlog3D Logo"
          style={{ height: "85px", verticalAlign: "middle", marginRight: "10px" }}
        />
        </Link>
        {window.location.hash !== "#/" && window.location.hash !== "" && (
          onBack ? (
            <button
              data-back-button
              className="header-icon color-theme header-icon-1"
              onClick={onBack}
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
            >
              <i className="fas fa-arrow-left"></i>
            </button>
          ) : (
            <Link to="/"
              data-back-button
              className="header-icon color-theme header-icon-1"
            >
              <i className="fas fa-arrow-left"></i>
            </Link>
          )
        )}
      </div>
    )
}

export default Header
